export const comments_3389327 = {"data":{"data":[],"links":{}}}